"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const native_1 = require("@react-navigation/native");
const toolkit_1 = require("@reduxjs/toolkit");
const react_1 = require("react");
const react_native_1 = require("react-native");
const screenConstants_1 = require("../constants/screenConstants");
const authSlice_1 = require("../features/auth/authSlice");
const homeSlice_1 = require("../features/home/homeSlice");
const store_1 = require("../store");
const analytics_1 = require("../utils/analytics/analytics");
const systemData_1 = require("../utils/systemData");
const useAppNavigation_1 = __importDefault(require("./useAppNavigation"));
const useGetUpdates = () => {
    const navigation = (0, useAppNavigation_1.default)();
    const dispatch = (0, store_1.useAppDispatch)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const { userId, appVersionStatus, triggerSendSystemInfo } = (0, store_1.useAppSelector)((state) => ({
        userId: state.auth.id,
        appVersionStatus: state.auth.app_version_status,
        triggerSendSystemInfo: state.auth.loginOrRegister,
    }));
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const getUpdateAux = async () => {
        const result = await dispatch((0, homeSlice_1.getUpdates)());
        logEventWithExtraProperties('api_call', {
            name: 'get_user_main_data',
            status: 'submitted',
            location: 'hook_useGetUpdates',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'get_user_main_data',
                status: 'success',
                location: 'hook_useGetUpdates',
            });
            setIsLoading(false);
            if (result.payload.user_data && !result.payload.user_data.email_confirmed) {
                navigation.reset({ index: 0, routes: [{ name: screenConstants_1.EMAIL_CONFIRMATION_PENDING_SCREEN }] });
            }
            else if (!result.payload.kyc.personal) {
                navigation.reset({ index: 0, routes: [{ name: screenConstants_1.ONBOARDING_PERSONAL_INFORMATION_SCREEN }] });
            }
            else if (!result.payload.kyc.business) {
                navigation.reset({ index: 0, routes: [{ name: screenConstants_1.ONBOARDING_BUSINESS_INFORMATION_SCREEN }] });
            }
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'get_user_main_data',
                status: 'fail',
                location: 'hook_useGetUpdates',
            });
            setIsLoading(false);
        }
    };
    (0, native_1.useFocusEffect)((0, react_1.useCallback)(() => {
        getUpdateAux();
        // send system info
        if (react_native_1.Platform.OS !== 'web' && triggerSendSystemInfo) {
            (0, systemData_1.requestLocationPermissions)();
            (0, systemData_1.getSystemData)(dispatch);
            (0, systemData_1.getUserLocation)(dispatch, userId);
        }
        if (react_native_1.Platform.OS !== 'web') {
            (0, systemData_1.getUserLocation)(dispatch, userId);
        }
        // APP VERSION STATUS
        if (react_native_1.Platform.OS !== 'web') {
            if (appVersionStatus === 'disabled') {
                dispatch((0, authSlice_1.logout)());
                dispatch((0, authSlice_1.setMessageDisabledApp)());
            }
            if (appVersionStatus === 'outdated') {
                dispatch((0, authSlice_1.setMessageOudatedApp)());
            }
        }
    }, []));
    return isLoading;
};
exports.default = useGetUpdates;
